<template>
<m-pageframe
    :title="title"
>
<v-container
    fluid
>

    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
        <v-menu
            bottom
            offset-y
            slot="append-outer"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>
    
            <v-list>
                <v-list-item
                    v-on:click="onClickAddEndpoints()"
                >
                    <v-list-item-title>Add Excluded Recipient(s)...</v-list-item-title>
                </v-list-item>
                
                <v-divider/>

                <v-list-item
                    v-on:click="onClickAddExcludedEndpointsTo()"
                >
                    <v-list-item-title>Add excluded recipients to another automated message...</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickCopyExcludedEndpointsTo()"
                >
                    <v-list-item-title>Make the excluded recipients on another automated message match...</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu> 
    </v-text-field>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
        <template v-slot:item.endpoint="{ item }">
            {{$rc.pretty(item.endpoint, 'endpoint_no_parens')}}
        </template>

        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical-circle-outline
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickDelete(item)"
                >
                    <v-list-item-title>Delete</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 
        </template>
    
    </v-data-table>

    <m-autocomplete-phone-number
        ref="add-phone-numbers"
        dialog_only
        :default_multiselect="true"
        action_button_text="Exclude Recipients"
        v-on:start-group-text="onExcludedRecipients"
    />

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');

export default {
    data() {
        return {
            organization_label: null,
            template: null,
            full_text: null,
            results: [],

            all_automated_messages: [],
            all_automated_message_choices: [],

            headers: [
                { text: 'Phone Number', value: 'endpoint'},
                { text: 'First Name', value: 'first_name'},
                { text: 'Last Name', value: 'last_name'},
                { text: 'Action', value: 'action'},
            ],
        }
    },

    mounted () {
        this.updateAllAutomatedMessages();
        this.updateTemplateSettings();
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/auto-messages/exclude-endpoint',
            
                'params' : {
                        'organization_id' : this.$route.params.organization_id,
                        'template_subject_id' : this.$route.params.template_subject_id,
                        'template_context' : this.$route.params.template_context,
                        'full_text': this.full_text,
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                    },
            
                'on_error': 'Unable to list excluded recipients',
            });
        },

        updateAllAutomatedMessages()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/auto-messages/org-profile',
            
                'params' : {
                        'organization_id': this.$route.params.organization_id,
                    },
            
                'on_success': (data) => {

                        let templates = data.templates.filter(
                            (el) => el.organization_id != this.$route.params.organization_id || el.template_subject_id != this.$route.params.template_subject_id || el.template_context != this.$route.params.template_context
                        ); // Remove this automated message from the list (can not copy to yourself)
                        
                        this.all_automated_messages = templates.map(
                            (el) => { return {
                                ... el,
                                'key': el.template_subject_id+':'+el.template_context,
                            }; }
                        );

                        this.all_automated_message_choices = this.all_automated_messages.map(
                            (el) => { return {
                                    'text': el.template_label,
                                    'value': el.key,
                                };
                            }
                        );

                    },
            
                'on_error': 'Unable to list automated messages',
            });
        },
        

        updateTemplateSettings() {
            let params = {
                'organization_id' : this.$route.params.organization_id,
                'template_subject_id' : this.$route.params.template_subject_id,
                'template_context' : this.$route.params.template_context,
            };

            this.$rc.showSpinner();
            
            this.$rc.getAutoMessageTemplateProfile(
                params,
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.organization_label = data.organization_label;
                    this.template = data.template;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to get automated message template');
                },
            );
        },

        onClickAddEndpoints()
        {
            this.$refs['add-phone-numbers'].showDialog();
        },

        onExcludedRecipients(endpoints)
        {
            endpoints = endpoints.map(
                (el) => { return {
                    'organization_id' : this.$route.params.organization_id,
                    'template_subject_id' : this.$route.params.template_subject_id,
                    'template_context' : this.$route.params.template_context,
                    'endpoint': el.value,
                }; }
            );

            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/auto-messages/exclude-endpoints',
            
                'params' : {
                        'endpoints': endpoints,
                    },
            
                'on_success': (data) => {
                        this.doUpdate();
                    },
            
                'on_error': 'Unable to exclude recipients',
            });
        },

        onClickDelete(item)
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'DELETE: /api/v1/auto-messages/exclude-endpoint',
            
                'params' : item,
            
                'on_success': (data) => {
                        this.doUpdate();
                    },
            
                'on_error': 'Unable to delete excluded recipient',
            });
        },

        onClickAddExcludedEndpointsTo()
        {
            this.$rc.pick({
                'title': 'Automated Message to Add Excluded Endpoints To',
                'content_before': 'Target',
                'content_after': 'Note: any excluded recipients *already present* in the target automated message will remain present',
            
                'choices': this.all_automated_message_choices,
            
                'multiple': true,
                'type': 'select',
                'select_label': 'Choose Automated Messages',
                'initial_value': null,
                'unset_label': null,
            
                'on_ok': (value) => {
                    

                    let target = this.all_automated_messages.filter(
                        (el) => value.includes(el.key)
                    );

                    this.doAddExcludedEndpointsTo(target);
                },
            
                'on_cancel': () => {}
            });
        },

        doAddExcludedEndpointsTo(targets)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/auto-messages/exclude-endpoint/add-excluded-endpoints-to',
            
                'params' : {
                        'source': {
                            'organization_id' : this.$route.params.organization_id,
                            'template_subject_id' : this.$route.params.template_subject_id,
                            'template_context' : this.$route.params.template_context,
                        },

                        'dest': targets,
                    },
            
                'on_success': (data) => {
                        this.$rc.alert('Complete', 'All excluded recipients have been added to the excluded recipients on the selected automated messages');
                    },
            
                'on_error': 'Unable to add excluded recipients to the selected automated messages',
            });
        },

        onClickCopyExcludedEndpointsTo()
        {
            this.$rc.pick({
                'title': 'Automated Message to Copy Excluded Endpoints To',
                'content_before': 'Target',
                'content_after': 'Note: the target automate message(s) will have the *same* excluded recipients as this automated message',
            
                'choices': this.all_automated_message_choices,
            
                'multiple': true,
                'type': 'select',
                'select_label': 'Choose Automated Messages',
                'initial_value': null,
                'unset_label': null,
            
                'on_ok': (value) => {
                    

                    let target = this.all_automated_messages.filter(
                        (el) => value.includes(el.key)
                    );

                    this.doCopyExcludedEndpointsTo(target);
                },
            
                'on_cancel': () => {}
            });
        },

        doCopyExcludedEndpointsTo(targets)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/auto-messages/exclude-endpoint/set-excluded-endpoints-to-match',
            
                'params' : {
                        'source': {
                            'organization_id' : this.$route.params.organization_id,
                            'template_subject_id' : this.$route.params.template_subject_id,
                            'template_context' : this.$route.params.template_context,
                        },

                        'dest': targets,
                    },
            
                'on_success': (data) => {
                        this.$rc.alert('Complete', 'All excluded recipients have been copied to the excluded recipients on the selected automated messages');
                    },
            
                'on_error': 'Unable to copy excluded recipients to the selected automated messages',
            });
        },
    },

    computed: {
        title() {
            let ol = this.organization_label;
            let template = this.template;

            if ( ol == null || template == null )
                return "Excluded Recipients";

            return 'Excluded Recipients: '+template.template_label;
        },
    },
}
</script>

<style lang="scss" scoped>
</style>